/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import AddToCalendar from 'react-add-to-calendar';
import InfiniteScroll from 'react-infinite-scroll-component';
import ReactPaginate from 'react-paginate';
import { isMobile } from '../../utils/helpers';

import Rosacruz from '../../assets/img-rosacruz.png';

import './Activities.css';


const Activity = ({ activity }) => {
  const [openActivity, setOpenActivity] = useState(false);

  // eslint-disable-next-line eqeqeq
  const acvitityType = activity.fk_idPublico == 1 ? 'publico' : 'privado';

  let dataInicial = moment(activity.dataInicial).format('YYYYMMDDTHHmmssZ');

  let dataFinal = moment(activity.dataFinal).format('YYYYMMDDTHHmmssZ');

  let activityName = '';

  if (activity.complementoNomeAtividade) {
    activityName = activity.complementoNomeAtividade;
  } else if (activity.nomeTipoAtividadeEstatuto) {
    activityName = activity.nomeTipoAtividadeEstatuto;
  }

  if (activity.dataInicial) {
    if (activity.dataInicial === '0000-00-00') {
      dataInicial = moment().format('YYYY-MM-DDTHH:mm:ss');
      dataFinal = moment().format('YYYY-MM-DDTHH:mm:ss');
    }
  }


  const handleActivityClick = () => {
    setOpenActivity(!openActivity);
  };

  const event = {
    title: `${activity.nomeTipoAtividadeEstatuto}`,
    description: `${activity.observacoes}`,
    location: `${activity.local}`,
    startTime: `${dataInicial}`,
    endTime: `${dataFinal}`,
  };

  return (
    <div className="activity">
      <div className="activity-infos">
        <div className="activity-header d-flex" onClick={() => handleActivityClick(activity)}>
          <div>
            <img src={Rosacruz} alt="Ativdade TOM" title="Atividade TOM" className="pr-3" />
          </div>
          <div className="activity-body">
            <h2>{activityName}</h2>
            <p>
              {activity.dataInicial !== '0000-00-00' ? `Dia: ${moment(activity.dataInicial).format('DD/MM/YYYY')} ${activity.horaInicial ? `| Hora: ${activity.horaInicial}` : ''}` : `${activity.diasHorarios}`}
            </p>
            <div className="activity-cards">
              {acvitityType === 'privado' ? (
                <div className="activity-card private-card">
                  APENAS MEMBROS
                </div>
              ) : (
                <div className="activity-card public-card">
                    NÃO MEMBROS
                </div>
              )}

            </div>
            <div className={`activity-obs ${openActivity && 'active'}`}>
              <p>{activity.observacoes}</p>
            </div>
          </div>
        </div>
        <AddToCalendar
          buttonLabel=""
          event={event}
          listItems={
            [
              { google: 'Google' },
              { outlookcom: 'Outlook' },
              { apple: 'Apple Calendar' },
            ]
          }
        />

      </div>
    </div>
  );
};

function Activities(props) {
  const [hasMoreActivities, setHasMoreActivities] = useState(true);
  const [itemsLength, setItemsLength] = useState(5);
  const [items, setItems] = useState([]);

  useEffect(() => {
    const activities = props.activities.slice(0, itemsLength);
    const newItems = [];
    Object.keys(activities).map((key) => newItems.push(
      <Activity activity={props.activities[key]} key={Math.random()} />,
    ));
    setItems(newItems);
  }, [itemsLength, props.activities]);

  const loadItens = () => {
    const activities = props.activities.slice(0, itemsLength);
    const newItems = [];
    Object.keys(activities).map((key) => newItems.push(
      <Activity activity={activities[key]} key={Math.random()} />,
    ));
    return newItems;
  };

  const loadMoreActivities = () => {
    setTimeout(async () => {
      await setItems(loadItens());
      if (itemsLength < props.activities.length) {
        setItemsLength(itemsLength + 10);
      } else {
        setHasMoreActivities(false);
      }
    }, 200);
  };

  function handlePageClick(val) {
    const offset = Math.ceil(val.selected * itemsLength);

    const activities = props.activities.slice(offset, (offset + itemsLength));

    const newItems = [];

    Object.keys(activities).map((key) => newItems.push(
      <Activity activity={activities[key]} key={Math.random()} />,
    ));

    setItems(newItems);
  }

  if (props.loading) {
    return (
      <div className=" col-12 d-flex justify-content-center pt-3">
        <div className="lds-ring">
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    );
  }
  if (props.activities.length === 0) {
    return (
      <div className="oa">
        <div className="oa-infos text-center">
          <h2 className="info-text">Não encontramos nenhuma atividade para o organismo afiliado.</h2>
        </div>
      </div>
    );
  }
  if (isMobile()) {
    return (
      <div className="activities-block">
        <InfiniteScroll
          dataLength={itemsLength}
          next={() => loadMoreActivities()}
          hasMore={hasMoreActivities}
          loader={(
            <div className="col-12 p-0 d-flex justify-content-center">
              <div className="lds-ring">
                <div />
                <div />
                <div />
                <div />
              </div>

            </div>
          )}
        >
          {items}
        </InfiniteScroll>
      </div>
    );
  }
  return (
    <>
      {items}
      <div className="d-flex justify-content-center pb-3">
        <ReactPaginate
          pageCount={Math.ceil(props.activities.length / 5)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={2}
          previousLabel="Anterior"
          nextLabel="Próximo"
          onPageChange={(val) => handlePageClick(val)}
          containerClassName="paginate"
          subContainerClassName="pages pagination"
          activeClassName="active"
        />
      </div>

    </>
  );
}

const mapStateToProps = (store) => ({
  activities: store.activitiesState.activities,
  loading: store.activitiesState.loading,
});

export default connect(mapStateToProps)(Activities);
